export class AzureSqlDatabaseRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "serverName",
            "baseName": "serverName",
            "type": "string",
            "format": ""
        },
        {
            "name": "adminUserName",
            "baseName": "adminUserName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "virtualNetworkName",
            "baseName": "virtualNetworkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "virtualNetworkResourceGroupName",
            "baseName": "virtualNetworkResourceGroupName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlDatabaseRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
